import CoreContentCards from './CoreContentCards';

export { type CoreContentCardsProps } from './CoreContentCards';
export default CoreContentCards;
